import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const QualityTrendsChart = () => {
  const chartData = [
    { month: 'Jan', passRate: 94.2, batchCount: 45, complianceScore: 96.1 },
    { month: 'Feb', passRate: 95.8, batchCount: 52, complianceScore: 97.3 },
    { month: 'Mar', passRate: 93.1, batchCount: 48, complianceScore: 95.8 },
    { month: 'Apr', passRate: 96.4, batchCount: 55, complianceScore: 98.2 },
    { month: 'May', passRate: 94.7, batchCount: 49, complianceScore: 96.9 },
    { month: 'Jun', passRate: 97.2, batchCount: 58, complianceScore: 98.7 },
    { month: 'Jul', passRate: 95.3, batchCount: 51, complianceScore: 97.1 },
    { month: 'Aug', passRate: 96.8, batchCount: 54, complianceScore: 98.4 },
    { month: 'Sep', passRate: 94.9, batchCount: 47, complianceScore: 96.5 }
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-modal">
          <p className="font-medium text-popover-foreground mb-2">{`${label} 2024`}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry?.color }}>
              {`${entry?.name}: ${entry?.value}${entry?.dataKey === 'batchCount' ? '' : '%'}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Quality Control Trends</h3>
          <p className="text-sm text-muted-foreground">Monthly performance metrics and compliance scores</p>
        </div>
        <div className="flex items-center space-x-4 text-xs">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-primary rounded-full"></div>
            <span className="text-muted-foreground">Pass Rate</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-success rounded-full"></div>
            <span className="text-muted-foreground">Compliance Score</span>
          </div>
        </div>
      </div>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              fontSize={12}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              fontSize={12}
              domain={[90, 100]}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line 
              type="monotone" 
              dataKey="passRate" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              dot={{ fill: 'var(--color-primary)', strokeWidth: 2, r: 4 }}
              name="Pass Rate"
            />
            <Line 
              type="monotone" 
              dataKey="complianceScore" 
              stroke="var(--color-success)" 
              strokeWidth={2}
              dot={{ fill: 'var(--color-success)', strokeWidth: 2, r: 4 }}
              name="Compliance Score"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default QualityTrendsChart;